
import { Shield, Lock, AlertTriangle } from "lucide-react";

const benefits = [{
  icon: Shield,
  title: "SSL-Secured Searches",
  description: "All your web searches are protected with advanced SSL encryption, ensuring your queries remain private and secure",
  gradient: "from-blue-500 to-cyan-500"
}, {
  icon: Lock,
  title: "Advanced Encryption",
  description: "Military-grade encryption protects your search data from prying eyes and malicious interceptors",
  gradient: "from-indigo-500 to-purple-500"
}, {
  icon: AlertTriangle,
  title: "Security Alerts",
  description: "Automatically highlights and warns you about non-secure search results, keeping you safe from malicious websites",
  gradient: "from-orange-500 to-red-500"
}];

const Benefits = () => {
  return (
    <div className="py-24 bg-white relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #3b82f6 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-4">
            Security-First Search Experience
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Experience the web with confidence through our comprehensive security features
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-gray-200 transform hover:-translate-y-2">
                {/* Icon with gradient background */}
                <div className="relative mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-r ${benefit.gradient} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <benefit.icon className="w-8 h-8 text-white" />
                  </div>
                  <div className={`absolute inset-0 w-16 h-16 bg-gradient-to-r ${benefit.gradient} rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity duration-300`}></div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-700 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-base">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
